import PropTypes from "prop-types";
import { List, LayoutGrid } from "lucide-react";
import { cn } from "@/lib/utils";

export function ContactViewToggle({ view, onChange }) {
  return (
    <fieldset
      className="inline-flex items-center rounded-lg border border-slate-200 bg-white p-0.5 shrink-0 m-0 min-w-0"
      data-testid="contact-view-toggle"
    >
      <legend className="sr-only">Contact view</legend>
      <button
        type="button"
        onClick={() => onChange("list")}
        className={cn(
          "inline-flex items-center justify-center gap-1.5 rounded-md px-2.5 min-h-10 sm:min-h-0 py-2 sm:py-1.5 text-[12px] font-medium transition-colors",
          view === "list"
            ? "bg-indigo-50 text-indigo-700"
            : "text-slate-500 hover:text-slate-800 hover:bg-slate-50",
        )}
        data-testid="contact-view-list"
        aria-pressed={view === "list"}
        aria-label="List view"
      >
        <List size={13} strokeWidth={2} />
        <span className="hidden sm:inline">List View</span>
      </button>
      <button
        type="button"
        onClick={() => onChange("grid")}
        className={cn(
          "inline-flex items-center justify-center gap-1.5 rounded-md px-2.5 min-h-10 sm:min-h-0 py-2 sm:py-1.5 text-[12px] font-medium transition-colors",
          view === "grid"
            ? "bg-indigo-50 text-indigo-700"
            : "text-slate-500 hover:text-slate-800 hover:bg-slate-50",
        )}
        data-testid="contact-view-grid"
        aria-pressed={view === "grid"}
        aria-label="Grid view"
      >
        <LayoutGrid size={13} strokeWidth={2} />
        <span className="hidden sm:inline">Grid View</span>
      </button>
    </fieldset>
  );
}

ContactViewToggle.propTypes = {
  view: PropTypes.oneOf(["list", "grid"]).isRequired,
  onChange: PropTypes.func.isRequired,
};
